import { Button, Card as CardUI } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
`;

export const Content = styled.div`
  margin: 25px 15px;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
`;

export const Form = styled.form`
  margin-top: 25px;
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;

  gap: 15px;
`;

export const Column = styled.div`
  width: 100%;
`;

export const Card = styled(CardUI)`
  display: flex;
  height: 90px;
  padding: 12px;
  justify-content: space-between;
  align-items: center;
`;

export const CardContentData = styled.div`
  color: ${({ color }) => color === "disabled" && "#A9A9A9"};
`;
export const CardContentActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ContentPagination = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const ContainerStatus = styled.div<{ colorTheme?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  padding: 3px 6px;
  height: 24px;
  width: auto;
  gap: 4px;

  border: 1px solid
    ${({ theme, colorTheme }) =>
      colorTheme === "success"
        ? theme.palette.success.light
        : theme.palette.error.light};
  span {
    line-height: 0;
  }
  color: ${({ theme, colorTheme }) =>
    colorTheme === "success"
      ? theme.palette.success.light
      : theme.palette.error.light};
`;

export const ButtonAction = styled(Button)`
  display: flex;
  align-items: center;
  transition: opacity 0.2s !important;

  &:hover {
    opacity: ${({ theme }) => theme.palette.action.hoverOpacity};
    background-color: transparent !important;
  }
`;

export const ContentOrders = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const NumberNewOrders = styled.div`
  margin-right: 12px;
`;
export const NumberProgressOrders = styled.div``;
